module.exports = __webpack_public_path__ + "static/media/file.80e7f05b.png";